<template>
  <div class="applets">
    <!-- <h2>小程序界面</h2> -->
    <div class="applets-pic">
      <p class="head-title">客服微信</p>
      <img src="../assets/kefu.png" alt="" />
      <p class="foot-title">扫码添加</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Applets",
};
</script>

<style scoped>
.applets {
  display: flex;
  justify-content: center;
}
.applets-pic {
  width: 40%;
  height: 50%;
  text-align: center;
  margin-top: 200px;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.head-title {
  font-size: 20px;
  font-weight: 600;
}
.foot-title {
  font-size: 20px;
  font-weight: 600;
}
.applets-pic img  {
  width: 50%;
}
/* .applets-pic {
    width: 1339px;
    height: 929px;
    position: relative;
}
.applets-pic img {
    width: 200px;
    height: 200px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -100px;
    margin-left: -100px;
} */
</style>